import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

import { AuthSessionService } from '../services/auth-session.service';

export const authGuard: CanActivateFn = async (_route, state) => {
  const authSession = inject(AuthSessionService);
  const router = inject(Router);

  const authenticated = await authSession.ensureAuthenticated();
  if (authenticated) {
    return true;
  }

  return router.createUrlTree(['/login'], {
    queryParams: {
      returnUrl: state.url,
    },
  });
};
